import React from 'react';
import { connect } from "react-redux";
import PortletSpinner from '../../../partials/layout/PortletSpinner';
import DataGridBase from '../../../partials/layout/DataGridBase';
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import { injectIntl } from "react-intl";
import { systemStatus, companyTypes, countries, companyTagCategories } from "../../../shared/lookup";
import { Badge } from "react-bootstrap";
import * as companiesCrud from "../../../crud/companies.crud";
import { withSnackbar } from 'notistack';
import { withRouter } from '../../../shared/hoc/withRouter';
import { GetAccessRights } from "../../../router/Protector/Protector";
import * as tagCrud from '../../../crud/tag.crud';
import { listAccountsAllowedRegisterBatchOperations } from '../../../router/Protector/AccessExceptions';

class CompaniesRegister extends React.Component {
  constructor(props) {
    super(props);
    this.companyTagsEnabled = process.env.REACT_APP_CONTRACT_COMPANY_TAGS_ENABLED === 'true';
    this.canCreateNew = GetAccessRights("/admin/companies/new-company", this.props.userProfile).allowAccess;

    this.batchOperationsEnabled = false;
    if (process.env.REACT_APP_BATCH_OPERATIONS_ENABLED === "true") {
        //REGISTER SUPPORTS BATCH OPERATION
        if (listAccountsAllowedRegisterBatchOperations.includes(this.props.userProfile.accounttype)) {
            this.batchOperationsEnabled = true;
        }
    }

    this.state = {
      companies: null,
      frameworkFilter: null
    }
  }

  componentDidMount() {
    this.fetchCompanies();
  }

  getFormFieldsOnceDownloadTemplateForBatchButtonClicked = async () => {
    return await this.setTags(0);
  }

  getFormConfig = (tags) => {
      const formFields = [
          {
              caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_NAME' }),
              dataField: 'name',
              required: true,
              dataType: 'string'
          }
      ];

      var comTypes = companyTypes.map(ty => ({ value: ty.value, display: this.props.intl.formatMessage({ id: "OPTIONS.COMPANY_TYPE." + ty.value }) }));

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_TYPE' }),
          dataField: 'companytype',
          required: true,
          dataType: 'list',
          options: {
              dataSource: comTypes,
              valueExpr: 'value',
              displayExpr: 'display'
          }
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_ADDRESS1' }),
          dataField: 'address1',
          required: true,
          dataType: 'string'
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_ADDRESS2' }),
          dataField: 'address2',
          required: false,
          dataType: 'string'
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_CITY' }),
          dataField: 'city',
          required: true,
          dataType: 'string'
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_COUNTY' }),
          dataField: 'state',
          required: true,
          dataType: 'string'
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_COUNTRY' }),
          dataField: 'country',
          required: true,
          dataType: 'list',
          options: {
              dataSource: countries
          }
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_POSTCODE' }),
          dataField: 'postcode',
          required: true,
          dataType: 'string'
      });

      if (this.props.protectedRouteProps.allowEnablingCompanyUsers) {

        const options = [{ value: 1, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}, { value: 0, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}];

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_ENABLECOMPANYUSERS' }),
            dataField: 'enablecompanyusers',
            required: true,
            dataType: 'list',
            options: {
                dataSource: options,
                valueExpr: 'value',
                displayExpr: 'display'
            }
        });
      }

      if (this.props.protectedRouteProps.allowEnablingCompanyUsers) {
        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_ADDCOMPANYUSERSTO' }),
            dataField: 'adduserstocompanyid',
            required: false,
            dataType: 'integer'
        });
      }

      const companyTagsEnabled = process.env.REACT_APP_CONTRACT_COMPANY_TAGS_ENABLED === 'true';

      if (companyTagsEnabled) {
        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'CONTRACT.FIELD.FRAMEWORKS' }),
            dataField: 'frameworkids',
            required: false,
            dataType: 'multi',
            options: {
              dataSource: tags,
              valueExpr: 'tagid',
              displayExpr: 'name'
            }
        });
      };

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_NUMBER' }),
          dataField: 'companynumber',
          required: false,
          dataType: 'string'
      });

      return formFields;
  }

  setTags = async (companyid) => {
    return tagCrud.GetTagsForCategory(companyTagCategories, companyid)
      .then(response => {
        const tags = response.data;
        const formFields = this.getFormConfig(tags);
        return formFields;
      })
      .catch(err => {
        this.props.enqueueSnackbar(err.toString(), { variant: 'error' });
      });
  }

  fetchCompanies = () => {
    companiesCrud.getCompaniesIncludingDeactives()
      .then(response => {
        let companies = JSON.parse(response.data.aggregatelist);
        if (companies) {
            companies = companies.map(company => {
                if (company.tags && company.tags.categories) {
                    const companyFrameworks = company.tags.categories.find(ctg => ctg.name === 'Frameworks');
                    if (companyFrameworks && companyFrameworks.tags) {
                      company.framework = companyFrameworks.tags.map(tag => tag.tagname);
                    }
                }
                return company;
            })
        }

        let frameworkFilter = null;
        if (response.data.uniquetags) {
            const allUniquieTags = response.data.uniquetags;
            if (allUniquieTags) {
                const frameworktags = allUniquieTags.categories.find(ctg => ctg.name === 'Frameworks');
                if (frameworktags && frameworktags.tags) {
                    frameworkFilter = frameworktags.tags.map(tag => ({ text: tag, value: ['framework', 'contains', tag] }));
                    frameworkFilter.push({
                        text: 'Blank',
                        value: ['framework', '=', null]
                    });
                }
            }
        }
      
        this.setState({ companies, frameworkFilter });
      })
      .catch(err => {
        this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
      });
  }

  onTableSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData.length > 0) {
      const data = selectedRowsData[0];
      this.props.navigate(`/admin/companies/${data.companyid}/overview`);
    }
  }

  renderStatusColumn = (cellInfo) => {
    let badgeVariant = 'secondary';
    let label = '';
    switch (cellInfo.data.deactivated) {
      case 1:
        label = this.props.intl.formatMessage({ id: "GENERAL.ACCOUNT.STATUS_DEACTIVATED" })
        badgeVariant = 'secondary';
        break;
      case 0:
        label = this.props.intl.formatMessage({ id: "GENERAL.ACCOUNT.STATUS_ACTIVE" })
        badgeVariant = 'success';
        break;
      default:
        break;
    }
    return (<Badge variant={badgeVariant}>{label}</Badge>);
  }

  render() {
    if (!this.state.companies ) {
      return (<PortletSpinner />);
    }

    const columns = [
      { caption: this.props.intl.formatMessage({ id: "COMPANY.FIELD.COMPANY_ID" }), dataField: "companyid" },
      { caption: this.props.intl.formatMessage({ id: "COMPANY.FIELD.COMPANY_NAME" }), dataField: "name" },
      { caption: this.props.intl.formatMessage({ id: "COMPANY.FIELD.COMPANY_TYPE" }), dataField: "companytype" },
      { caption: this.props.intl.formatMessage({ id: "COMPANY.FIELD.COMPANY_ADDRESS1" }), dataField: "address1" },
      { caption: this.props.intl.formatMessage({ id: "COMPANY.FIELD.COMPANY_ADDRESS2" }), dataField: "address2" },
      { caption: this.props.intl.formatMessage({ id: "COMPANY.FIELD.COMPANY_COUNTY" }), dataField: "state" },
      { caption: this.props.intl.formatMessage({ id: "COMPANY.FIELD.COMPANY_COUNTRY" }), dataField: "country" }
    ];

    if (!(process.env.REACT_APP_PRODUCT_KEY === "NG" && process.env.REACT_APP_ENVIRONMENT === 'PROD')) {
      columns.push({ caption: this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.STATUS" }), dataField: "deactivated", cellRender: this.renderStatusColumn, lookup: { dataSource: systemStatus, displayExpr: 'value', valueExpr: 'key' } })
    }
    
    columns.push(
      { resource: "COMPANY.FIELD.COMPANY_ENABLECOMPANYUSERS", dataField: "enablecompanyusers" },
      { resource: "COMPANY.FIELD.COMPANY_ADDCOMPANYUSERSTO", dataField: "adduserstocompanyid", lookup: { dataSource: this.state.companies, displayExpr: 'name', valueExpr: 'companyid' } },
      { resource: 'COMPANY.FIELD.COMPANY_NUMBER', dataField: 'companynumber' }
    )

    if (this.companyTagsEnabled) {
      columns.push(
          { resource: "CONTRACT.FIELD.FRAMEWORKS", dataField: "framework", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.frameworkFilter } }
      )
    }
  
    return (
      <Portlet>
        <PortletBody>
          <DataGridBase
            version="1"
            //BATCH OPS
            batchOperations={this.batchOperationsEnabled}
            //batchFormFields={this.state.formFields}//this field is null by default because we want to load formfields when download template button clicked
            batchImportEndpoint={companiesCrud.importCompanies}
            batchGetFormFieldsWithDownloadTemplateButton={this.getFormFieldsOnceDownloadTemplateForBatchButtonClicked}
            onBatchRecordsUpdated={this.fetchCompanies}
            customFields={this.props.customFields}
            //BATCH OPS
            title={this.props.intl.formatMessage({ id: "COMPANY.LIST.TITLE" })}
            createPath={this.canCreateNew ? "/admin/companies/new-company" : null}
            name={`Companies`}
            dataSource={this.state.companies}
            keyExpr="companyid"
            onSelectionChanged={this.onTableSelectionChanged}
            hoverStateEnabled={true}
            rowAlternationEnabled={false}
            columns={columns}
          />
        </PortletBody>
      </Portlet>
    );
  }
}

const mapStateToProps = store => ({
  userProfile: store.auth.userProfile
});

export default withRouter(withSnackbar(injectIntl(connect(mapStateToProps)(CompaniesRegister))));